import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { GendersList } from '@gtpl/shared-models/gtpl';

export class ProfileDTO {
  @ApiProperty()
  @ApiPropertyOptional()
  Id?: number;
  @ApiProperty({
    description: '10 digits mobile number - type: string but input should be only numeric ',
  })
  @ApiPropertyOptional()
  @MaxLength(10, { message: "Mobile number allows 10 characters only. " })
  mobileNo?:string;
  @ApiProperty({
    description: 'user first name - type: string',
  })
  @MaxLength(500, { message: "FirstName allows maximum 500 characters" })
 // @IsNotEmpty({message:"FirstName should not be empty"})
  firstName:string;
  @ApiProperty({
    description: 'user last name - type: string',
  })
  @ApiPropertyOptional()
  @MaxLength(500, { message: "LastName allows maximum 500 characters" })
  lastName: string;
  @ApiProperty({ description: 'user gender - type:string' ,enum: Object.values(GendersList) })
  @IsNotEmpty() gender: GendersList;
  @ApiProperty({
    description: 'user date of birth - type: date format: yyyy-mm-dd',
  })
  @ApiPropertyOptional()
  dob: Date;
  @ApiProperty({
    description: 'user address - type: string',
  })
  address: string;
  @ApiProperty({
    description: 'user  - type: integer from villages by search',
  })
  @ApiPropertyOptional()
  villageId?: number;
  @ApiProperty({
    description: 'user  - type: integer user role',
  })
  @ApiPropertyOptional()
  roleId?: number;
  @ApiProperty({
    description: 'user email - type: string',
  })
  @ApiPropertyOptional()
  email?: string;
  @ApiProperty({
    description: 'logged in user id - type: integer',
  })
  userId:number;
  @ApiProperty()
  @ApiPropertyOptional()
  BloodDonner:boolean;
  @ApiProperty()
  @ApiPropertyOptional()
  BGroupId:number;
  @ApiProperty()
  @ApiPropertyOptional()
  otherPic?:string;
  @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } , description:'upload image type:file'})
  @ApiPropertyOptional()
  otherPicImg?:any[];
  @ApiProperty()
  @ApiPropertyOptional()
  membershipImg?:string;
  @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } , description:'upload image type:file'})
  @ApiPropertyOptional()
  membershipPic?:any[];
  @ApiProperty()
  @ApiPropertyOptional()
  membershipId:string;
  @ApiProperty()
  status: boolean;
  createdAt : Date;
  updatedAt : Date;
  @ApiProperty({
    description: 'api version number - type: integer',
    minimum:1,
    default:1
  })
  versionFlag : number;
}

export class ProfilePicDTO {
  @ApiProperty({
    description:'user id = type:integer'
  })
  @IsNotEmpty({message:"userId should not be empty"})
  userId: number;
  @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } , description:'upload image type:file'})
  profilePic:any[];
}


export class FBDTO {
  @ApiProperty()
  @ApiPropertyOptional()
  Id?: number;
  @ApiProperty()
  userPageId:string;
  @ApiProperty()
  @ApiPropertyOptional()
  pageName:string;
  @ApiProperty()
  accessToken: string;
  @ApiProperty({
    description: 'if page send 1 or else 0',
  })
  pageIndicator: number;
  @ApiProperty()
  createdBy: number;
  status:boolean;
  createdAt : Date;  
}

